import { FC } from 'react';

import Button from '~components/generic/elements/Button';

export interface IGitHubButtonProps {
  link: string;
}

const GitHubButton: FC<IGitHubButtonProps> = ({ link }) => {
  if (typeof link !== 'string') {
    return null;
  }

  return (
    <Button
      className="u-size-xs c-button c-button--light u-margin-left-md u-padding-horizontal-md"
      name="ui-component-github"
      label="View source code on GitHub"
      title="View source code on GitHub"
      href={link}
      rel="noopener noreferrer"
      target="_blank"
      hideLabel={true}
      iconName="github"
      iconCentered={false}
    />
  );
};

export default GitHubButton;
